import BadgeCarousel from "@/components/BadgeCarousel";
import badgeName from "@/utils/badgeName";
import cx from "classnames";
import React, {ReactElement, useEffect} from "react";
import Link from "next/link";
import {AiFillFire} from "react-icons/ai";

const getBottomBadges = (metadata, username): (ReactElement | string)[] => {
    const badgesSet = new Set<ReactElement | string>();

    if (metadata?.badges) {
        metadata?.badges.forEach((badge) => {
            badgesSet.add(badge);
        })
    }

    if (metadata?.lookingForWork === true) {
        badgesSet.add('looking-for-work');
    }

    if (metadata?.settings?.smokeBuddy) {
        badgesSet.add(
            <Link
                className="bg-green-600 whitespace-nowrap px-1 z-[100] overflow-hidden !text-white w-full h-full block justify-center items-center flex"
                href={`/u/${username}/message?subject=SmokeBuddy`}>
                <span
                    className="lineHeight-0 text-[12px]">
                    <AiFillFire className="inline-block fill-white"/> SmokeBuddy
                </span>
            </Link>
        );
    }

    return Array.from(badgesSet);
}

const enhanceBadge = (badge, badgeName, username) => {
    if (badge === 'looking-for-work') {
        return <Link href={`/u/${username}/message?subject=looking for work`}>{badgeName}</Link>
    }

    if (badge === 'lunch-time-dab-time') {
        return <Link target="_blank" href="https://www.instagram.com/lunchtimedabtime/">{badgeName}</Link>
    }

    return badgeName;
}

export interface ProfileBadgesProps {
    metadata?: any;
    username?: string;
    title?: string;
    className?: string;
    badgeWidth?: number;
    maxBadgesCount?: number;
    showOnEmpty?: boolean;
    appendBadges?: any[];
}

export default function ProfileBadges({
                                          metadata,
                                          username,
                                          className,
                                          badgeWidth = 100,
                                          maxBadgesCount,
                                          showOnEmpty = false,
                                      }: ProfileBadgesProps) {
    const [badges, setBadges] = React.useState<(ReactElement | string)[]>([]);

    useEffect(() => {
        const generatedBadges = getBottomBadges(metadata, username);

        setBadges(() => generatedBadges);
    }, [metadata?.badges, metadata?.lookingForWork, metadata?.settings?.smokeBuddy]);

    if (badges.length === 0 && !showOnEmpty) {
        return null;
    }

    return (
        <div className={cx("relative h-[40px] flex-initial overflow-hidden", className)}>
            <BadgeCarousel badgeWidth={badgeWidth} speed={2400} maxBadgesCount={maxBadgesCount}
                           className="bg-dark-black border-t border-b border-gray-700 w-full h-full">
                {badges.map((badge) => {
                    if (typeof badge !== 'string') {
                        return badge;
                    }

                    return <div key={`badges-${badge}`}
                                className={`flex justify-center items-center badge-bottom-tag badge-tag-${badge} text-xs`}>{enhanceBadge(badge, badgeName(badge), username)}</div>
                })}
            </BadgeCarousel>
        </div>
    );
}